import React, { StrictMode, Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CommandCenterProvider } from "Components/CommandCenter/CommandCenterProvider";
import { Provider } from "react-redux";
import store from "./Redux/store";
import { BrowserRouter } from "react-router-dom";
import "./Styles/index.scss";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./Components/ErrorBoundary/ErrorBoundary";
import NiceModal from "@ebay/nice-modal-react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Suspense>
    {/* Last resort above the store and router, so it can only reload. Pages
        have their own boundary (PageErrorBoundary) inside the app shell. */}
    <ReactErrorBoundary
      fallbackRender={(props) => (
        <ErrorFallback
          {...props}
          resetErrorBoundary={() => window.location.reload()}
          retryLabel="Reload page"
        />
      )}
    >
      <Provider store={store}>
        <BrowserRouter>
          <NiceModal.Provider>
            <CommandCenterProvider>
              <App />
            </CommandCenterProvider>
          </NiceModal.Provider>
        </BrowserRouter>
      </Provider>
    </ReactErrorBoundary>
  </Suspense>,
);
